module.exports = __webpack_public_path__ + "img/MC.818adec2.png";